// extracted by mini-css-extract-plugin
export default {"root":"LinkButton_root__Cu3mA","fullWidth":"LinkButton_fullWidth__M3kEN"};